<div class="content-block">
    <app-header-banner [data]="banner"></app-header-banner>
    <div class="container" style="margin-top: 10px">
       <div class="row" style="display: flex;justify-content: center;">
        <img src="../../../../assets/images/alumni/11.jpg" alt="">
       </div> 
    </div>
</div>